class ShopFilter {
	constructor(array){
		this.array = array;
		this.res = [];
		this.itemCount = 1;
	}

	/*getLimit( limit, key ){
		this.array.filter( (item, idx) => {
			let k = item[key];
			if( k >= limit[0] && k <= limit[1] ){
				this.res.push(item);
			}
		})
	}*/

	/*getPages( limit ){
		this.array.filter( (item, idx) => {
			let lim = this.itemCount * limit;
			if( idx >= (lim-limit) && idx < limit ){
				this.res.push(item);
			}
		})
	}*/

	getWord(word, box, typo){
		this.res = [];
		this.array.filter( item => {
			let pattern = item['product']
			  .trim()
			  .search(word);
			  if( pattern != -1 ) this.res.push(item);
		});
		this.buildShop(this.res, box, typo);
	}

	setCompleteList(){
		let arr=[];
		this.array.forEach( item => {
			let t = (item['product'].split(" ")[0]).trim();
			if( !arr.includes(t) ) arr.push(t);
		});

		arr.forEach( (el, idx) => {
			this.addHtml(list_complete, 2, 'html', `<option value="${el}" data-index="${idx}" ${idx===0?" selected":""}>${el}</option>`);
		})
		return false;
	}

	/*beforeBuildShop(box, typo){
		let btn = `<div class="col-12 text-center">
		  <button type="button" class="btn btn-success moreitem" data-typo="${typo}">Load more</button>
		</div>`;
		let btnBox = document.getElementById(box+typo);
		btnBox.innerHTML = '';
		this.addHtml(btnBox, 2, 'html', btn);
	}

	buildShop(result, box, typo='Filter', limit){
		let resulto = result || this.array;
		box = box || 'productsFilter';
		limit = limit || 5;
		let tpl = function(product, image, price){
		  const [cost, integer, decimal] =  price.match(/^(\d+\.?\-?)(\d*)/);
			return `
			  <a href="item.html" class="article_link" data-model="${product}">
			    <img src="${image}" alt="${product} - ${price} /n id" />
			    <p class="item-text">${product}</p>
			    <span class="price item-price">${integer}${decimal ? "" : "-"}<span class="cents">${
					decimal ? (decimal + "0").slice(0, 2) : ""
				}</span></span>
			  </a>`;
		}

		let count = this.itemCount;
		let btnBox = document.getElementById(box+typo);
		if( count <= 1 ){
			this.beforeBuildShop('products', typo);
		}

		resulto.forEach( (el, idx) => {
			if( idx >= (limit * count - limit) && idx < (limit*count) ){
				this.addHtml(btnBox, 1, 'html', tpl( el['product'], el['image'], el['price']));
			}
			if( idx > limit*count) return;
		});

		this.itemCount += 1;
	}*/


	performSearchComplex(products, number) {
		//const page = typeof number === "number" ? number || this.itemCount : 1;
		const value = list_complete.value;
		products = products || this.array;
		const page = this.itemCount;
		//console.log(page);

		function fnSearchComplex(array, pattern, wholeWord) {
			var parts = pattern
				.trim()
				.toLowerCase()
				.split(/\s+/);

			return array.filter(function({ product }) {
				var description = product.toLowerCase().split(/\s+/);
				return parts.every(function(part) {
					return description.some(function(word) {
						return wholeWord ? word === part : word.startsWith(part);
					});
				});
			});
		}

		function comparator(order) {
			return [
				(a, b) => (a.product > b.product ? 1 : -1),
				(a, b) => (Number(a.price) > Number(b.price) ? 1 : -1),
				(a, b) => (Number(a.price) < Number(b.price) ? 1 : -1)
			][order];
		}

		const [min, max] = ((a, b) => (a > b ? [b, a] : [a, b]))(
			Number(price_min.value),
			Number(price_max.value)
		);

		range_display.childNodes[0].textContent = `Price (${min}...${max})`;

		const result = fnSearchComplex(
			products,
			value,
			exact_search.checked
		).filter(({ price }) => {
			price = Number(price);
			return min <= price && price <= max;
		});

		result.sort(comparator(order.value));

		let html = result
			.map(({ image, product, price }, index) => {
				if (
					index >=
					page * results_per_page.value
				)
					return ``;

				const [, integer, decimal] = price.match(/^(\d+\.?\-?)(\d*)/);
				return `<div class="article_link" data-model="${product}">
						<a href="item.html">
							<img class="rounded" src="${image}" alt="${product} - ${price} - [${index}]" onerror="this.src='uploads/onsearch.jpg';" />
							<p class="item-text ml-3 mr-3 pt-2">${product}</p>
						</a>
						<span class="price item-price">${integer}${decimal ? "" : "-"}
						  <span class="cents">${decimal ? (decimal + "0").slice(0, 2) : ""}</span>
						</span>
						<div class="btn-group-sm">
						<button type="button" class="btn btn-sm btn-success item-compare">compare +</button>
						<button type="button" class="btn btn-sm btn-success item-buy">buy</button>
						</div>
					</div>`;
			})
			.join("");

		if (
			result.length >
			page * results_per_page.value
		)
			html += `<div class="row"><div class="col-12 text-center">
					<button type="button" class="btn btn-success moreitem" data-typo="Filter">Load more</button>
				</div></div>`;

		productsFilter.innerHTML = html;
		this.itemCount += 1;
	}

	addHtml(el, numArea, metod, tpl){
	  //numArea=0|1|2|3; metod=html|text|elem
	  //let arrArea = ['beforebegin','beforeend','afterbegin','afterend'];
	  let mtd = {
	    html:'insertAdjacentHTML',
	    text:'insertAdjacentText',
	    elem:'insertAdjacentElement',
	    0:'beforebegin',
	    1:'afterbegin',
	    2:'beforeend',
	    3:'afterend'
	  };
	  el[mtd[metod]](mtd[numArea], tpl);
	  return this;
	}
}

fetch("json/data.json")
	.then( (response) => response.json())
	.then( (products) => {

		let shop = new ShopFilter(products);
		let page = shop.itemCount;
		//shop.buildShop(products, 'products', 'Filter', 4);
		shop.performSearchComplex(products, 1);
		shop.setCompleteList();

	document.addEventListener('click', function(e){
		let target = e.target;
		if( target.tagName === 'BUTTON' && target.classList.contains('moreitem')){
			let typo = target.getAttribute('data-typo')
			//shop.buildShop(products, 'products', typo, 2);
			//console.log('Click: '+ target.getAttribute('data-typo'));
			shop.performSearchComplex(products, page);
		}
		return false;
	});

	list_complete.addEventListener("input", function(e){
		shop.performSearchComplex(products, page);
		//shop.getWord(e.target.value, 'products', 'Filter');
	});

	//search.addEventListener("input", shop.performSearchComplex);
	price_min.addEventListener("change", function(){
		shop.performSearchComplex(products);
	});
	price_max.addEventListener("change", function(){
		shop.performSearchComplex(products)
	});
	order.addEventListener("change", function(){
		shop.performSearchComplex(products)
	});
	results_per_page.addEventListener("change", function(){
		shop.performSearchComplex(products)
	});
	//exact_search.addEventListener("change", shop.performSearchComplex);
		
});